(function () {
    'use strict';

    angular
        .module('vacationguard', [
            'app'
        ]);

})();
